<template>
  <div>
    <van-nav-bar
      title="提款地址"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="onSubmit" id="changePass">
      <van-field
        v-model="rePicCode"
        center
        clearable
        label="验证码"
        placeholder="请输入验证码"
      >
        <div slot="button">
          <img
            :src="captcha"
            @click="this.getCaptcha"
            style="height: 25px; width: 80px"
          />
        </div>
      </van-field>
      <van-field
        v-model="withdrawAddress"
        name="withdrawAddress"
        label="提款地址"
        placeholder="提款地址"
        :rules="[{ required: true, message: '请填写银行卡卡号' }]"
      />
      <div style="display: flex; justify-content: center">
        <van-button
          class="change_pass_btn"
          color="#D02E27"
          round
          block
          type="danger"
          size="small"
          native-type="submit"
          style="height: 50px"
        >
          确定
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import { version } from "../../package.json";
export default {
  name: "WithdrawAddress",
  data() {
    return {
      captcha: "",
      verify_token: "",
      rePicCode: "",
      version: version,
      withdrawAddress: ""
    };
  },
  computed: {},
  methods: {
    getWithdrawAddress() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.withdrawAddress = res.data.data.withdraw_address;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getCaptcha() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "getSmsPic",
            version: that.version
          }
        })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.captcha =
              localStorage.getItem("lineUrl") + resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$toast.fail(res.data.msg);
          }
        });
    },
    onSubmit() {
      let that = this;
      let publicKey = localStorage.getItem("encript_public_key");
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_withdraw_address",
            token: sessionStorage.getItem("token"),
            withdrawAdd: that.withdrawAddress,
            rePicCode: that.rePicCode,
            verify_token: that.verify_token
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
              onClose: function() {
                that.$router.push("/member/information");
              }
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
  },
  mounted: function() {
    this.isLogin();
    this.getCaptcha();
    this.getWithdrawAddress();
  }
};
</script>
<style scoped>
.change_pass_btn {
  position: fixed;
  bottom: 65px;
  width: 90%;
  margin-left: 3px;
  margin-bottom: 20px;
  font-size: 15px;
}
</style>
<style>
#changePass .van-field {
  background-color: #fafafa;
  margin: 20px;
  width: unset;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawAddress.vue